export const addressInfoInitialValues = {
  address: {
    street: '',
    city: '',
    zipCode: ''
  }
}